import * as React from "react";
import { useEffect } from "react";
import executeRequest from "../../../../../modules/request.js";
import SuggestionsImage from "../suggestionsImage/suggestionsImage.js";
import "./aiSuggestionsContainer.css";
export default function AiSuggestionsContainer(props) {
    const [suggestedImages, setSuggestedImages] = React.useState([]);
    useEffect(() => {
        executeRequest(`/api/public/users/image/${props.imageName}/aiSuggestions?ignoreOrdered=true`, "GET", {}).then((res) => {
            if (res.status != 200) {
                return;
            }
            console.log(res.results);
            const suggestions = [];
            for (const imgName in res.results) {
                if (imgName != props.imageName) {
                    suggestions.push({ name: imgName, distance: res.results[imgName] });
                }
            }
            setSuggestedImages(suggestions.sort((a, b) => a.distance - b.distance).map((a) => a.name));
        });
    }, []);
    return (React.createElement("div", { className: "ai-container" },
        React.createElement("b", null, suggestedImages.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement("h2", null, "Te zdj\u0119cia te\u017C mog\u0105 ci si\u0119 spodoba\u0107:")))),
        React.createElement("div", { className: "ai-images-container" }, suggestedImages.map((imgName, index) => (React.createElement(SuggestionsImage, { imageName: imgName, key: index, onOfferSelect: props.onExitRequest }))))));
}
